export function isAction(action) {
    return action.label !== undefined;
}
